module.exports = {
  XmlEntities: require('./lib/xml-entities.js'),
  Html4Entities: require('./lib/html4-entities.js'),
  Html5Entities: require('./lib/html5-entities.js'),
  AllHtmlEntities: require('./lib/html5-entities.js')
};



//////////////////
// WEBPACK FOOTER
// ../~/html-entities/index.js
// module id = 848
// module chunks = 0